<template>
  <div class="NewList_Case"  :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">
    <div class="Case_box">

      <div class="Case_box_left" ref="fixedTop" v-if="terminal == 'pc'">
        <div class :class="[fixed ? 'fixed_true' : '']">
          <div class="sdg_box">
            <div
              @click="toSdgsindicators(index)"
              class="sdg_box_img"
              v-for="(item, index) in sdgList"
              :key="index"
              :data-attr="`${item.name}`"
            >
              <img
                :src="
                  require(`../../../assets/image/Sdg/index_${index + 1}.png`)
                "
                alt
              />
            </div>
          </div>
          <!-- 分享 -->
          <!-- <div class="share">
            <div class="tit">{{ $t("NewList.Share") }}</div>
            <div class="share_icon" @click="share()">
              <el-popover
                placement="top-start"
                :title="$t('NewList.Share')"
                trigger="click"
                :content="$t('NewList.UnderDevelopment')"
              >
                <i class="iconfont icon-facebook-fill" slot="reference"></i>
              </el-popover>
              <el-popover
                placement="top-start"
                :title="$t('NewList.Share')"
                trigger="click"
                :content="$t('NewList.UnderDevelopment')"
              >
                <i class="iconfont icon-linkedin-fill" slot="reference"></i>
              </el-popover>
              <el-popover
                placement="top-start"
                :title="$t('NewList.Share')"
                trigger="click"
                :content="$t('NewList.UnderDevelopment')"
              >
                <i class="iconfont icon-twitter-square-fill" slot="reference"></i>
              </el-popover>
            </div>
          </div> -->
          <!-- 报告 -->
          <div class="report">
            <div class="tit">{{ $t("NewList.Report") }}</div>
            <div class="report_img" :data-title="$t('NewList.Report')" @click="toreport()">
              <img src="../../../assets/image/Index/RecentNew2.jpg" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="Case_box_right">
        <!-- <div class="Case_box_right_new_box"> -->
        <transition-group name="list" tag="div" class="Case_box_right_new_box">
          <div
            class="Case_box_right_new list-item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="toArticles(item.id)"
          >
            <div class="img_box">
              <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
            </div>

            <div class="Case_box_right_new_text">
              <div class="tit_box">
                <span class="tit">{{ item.title }}</span>
              </div>

              <div class="date">{{ item.releaseTime }}</div>
              <div class="content" v-html="$options.filters.formatTime(item.content, 60, 90)"></div>
              <div class="arrows">
                <i class="iconfont icon-youjiantou_huaban"></i>
              </div>
            </div>
          </div>
        </transition-group>
        <!-- </div> -->

     <div style="height: 60px" v-if="moreActive">
        <div class="more_new" @click="moreNewFun()" v-if="dataList.length > 0 && !moreShowBoolen">
          {{ $t("NewList.More") }}
        </div>
        <div  v-if="dataList.length == 0" class="noData">{{ $t("NewList.NoData") }}</div>
      </div>

        <div  v-if="!moreActive" style="height: 60px; margin: 40px auto">
              
          <NewLoading></NewLoading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  props: ["activeType", "dataList", "moreShowBoolen", "moreActive"],
  data() {
    return {
      fixed: false
    };
  },
  computed: {
    sdgList() {
      return [
        { name: this.$t("NewList.Goal1"), id: 1 },
        { name: this.$t("NewList.Goal2"), id: 1 },
        { name: this.$t("NewList.Goal3"), id: 1 },
        { name: this.$t("NewList.Goal4"), id: 1 },
        { name: this.$t("NewList.Goal5"), id: 1 },
        { name: this.$t("NewList.Goal6"), id: 1 },
        { name: this.$t("NewList.Goal7"), id: 1 },
        { name: this.$t("NewList.Goal8"), id: 1 },
        { name: this.$t("NewList.Goal9"), id: 1 },
        { name: this.$t("NewList.Goal10"), id: 1 },
        { name: this.$t("NewList.Goal11"), id: 1 },
        { name: this.$t("NewList.Goal12"), id: 1 },
        { name: this.$t("NewList.Goal13"), id: 1 },
        { name: this.$t("NewList.Goal14"), id: 1 },
        { name: this.$t("NewList.Goal15"), id: 1 },
        { name: this.$t("NewList.Goal16"), id: 1 },
        { name: this.$t("NewList.Goal17"), id: 1 }
      ];
    }
  },
  components: {
    NewLoading: () =>
      import("@/components/PublicComponents/NewLoading/NewLoading.vue")
  },
  filters: {
    formatTime: function(value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
            msg = msg.replace(/\s+/g, " "); //去掉npsp
      return msg.slice(0, zhNum).concat("......");
      // if (language == "zh") {
      //   return msg.slice(0, zhNum).concat("......");
      // } else {
      //   return msg.slice(0, enNum).concat("...");
      // }
    }
  },

  mounted() {
    // window.addEventListener("scroll", this.menu,false);
    // this.initVideo();
  },
  destroyed() {
    //  window.removeEventListener('scroll', this.menu, false)
  },
  methods: {
    toSdgsindicators(i) {
      this.$router.push(`/sdgsindicators`);
    },
    toreport() {
      this.$router.push("/sdgsreports");
    },
    moreNewFun() {
      bus.$emit("moreNew");
    },
    menu() {
      var scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scroll > 2340) {
        // this.fixed = true
      } else {
        //  this.fixed = false
      }
      //   let tabH = this.$refs.fixedTop.scrollTop;
      // let tabH1 = this.$refs.fixedTop.scrollHeight;
      // console.log(cc, tabH, tabH1);
    },

    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "800px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "400px"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .NewList_Case {
    background: #fff;
    // width: 1200px;
    width: 100%;
  }
  .Case_box {
    padding-top: 20px;
    width: 1200px;
    margin: 0px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;

    // height: 600px;
    .fixed_true {
      position: fixed;
      bottom: 50px;
      width: 322px;
      background: #f8f8f8;

      // padding: 5px;
    }
    .Case_box_left {
      padding: 0 10px;
      width: 322px;
      background: #f8f8f8;
      .sdg_box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .sdg_box_img {
          cursor: pointer;
          width: 150px;
          height: 150px;
          position: relative;
          &:hover::after {
            padding: 10px;
            opacity: 1;
            font-size: 16;
            transition: 0.5s ease;
          }
          &::after {
            opacity: 0;
            content: attr(data-attr);
            padding: 10px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            //  font-size: 36px;

            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
          }
          img {
            width: 100%;
            height: 100%;
            margin-bottom: 2px;
          }
        }
      }
      .share {
        margin-top: 36px;
        cursor: pointer;
        .tit {
          font-size: 24px;
          color: #000;
        }
        .share_icon {
          margin-top: 14px;
          i {
            font-size: 34px;
          }
          i:nth-child(1) {
            color: rgba(32, 89, 149, 1);
          }
          i:nth-child(2) {
            color: rgba(1, 154, 205, 1);
          }
          i:nth-child(3) {
            color: rgba(0, 171, 215, 1);
          }
        }
      }
      .report {
        cursor: pointer;
        margin-top: 40px;
        .tit {
          font-size: 24px;
          margin-bottom: 20px;
          color: #000;
        }
        .report_img:hover img {
          transition: 0.3s ease-in;
          transform: scale(1.2);
        }
        .report_img:hover::after {
          opacity: 1 !important;
          font-size: 20px;
          transition: 0.5s ease;
        }
        .report_img {
          position: relative;
          width: 302px;
          height: 174px;
          overflow: hidden;
        }
        .report_img::after {
          z-index: 1;
          content: attr(data-title);
          color: #fff;
          font-size: 36px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.3);
        }
        img {
          width: 302px;
          height: 174px;
          transition: 0.3s ease-in;
          object-fit: cover;
        }
      }
    }
    .Case_box_right {
      width: 844px;
      .Case_box_right_new:hover .Case_box_right_new_text .tit {
        background-size: 100% 2px !important;
      }
      .Case_box_right_new_box {
        display: flex;
        flex-direction: column;
        .Case_box_right_new:nth-child(even) {
          display: flex;
          flex-direction: row-reverse;
          .img_box {
            width: 342px;
            height: 255px;
            overflow: hidden;
            margin-left: 24px;
            img {
              transition: 0.2s;
              width: 342px;
              height: 255px;
              object-fit: cover;
            }
          }
        }
        .Case_box_right_new:nth-child(odd) {
          display: flex;
          flex-direction: row;
          .img_box {
            width: 342px;
            height: 255px;
            overflow: hidden;
            margin-right: 24px;
            img {
              width: 342px;
              height: 255px;
              object-fit: cover;
            }
          }
        }
        .Case_box_right_new:hover {
          background: #f8f8f8;
        }

        .Case_box_right_new {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 40px 0px;
          border-bottom: 1px solid #ccc;
          &:hover .img_box img {
            transition: 0.2s;
            transform: scale(1.1);
          }

          .Case_box_right_new_text {
            flex: 1;
            .tit_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;

              color: #fff;
              font-size: 24px;
              font-weight: 600;
              margin-bottom: 15px;

              .tit {
                background-image: linear-gradient(
                  rgba(0, 104, 157, 1),
                  rgba(0, 104, 157, 1)
                );
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
                color: rgba(0, 104, 157, 1);
                font-size: 28px;
              }
            }

            .date {
              margin-top: 10px;
              font-size: 24px;
              color: rgba(10, 151, 217, 1);
            }
            .content {
              color: rgba(51, 51, 51, 1);
              font-size: 16px;
              margin-top: 10px;
            }
            .arrows {
              text-align: right;
              margin: 10px;
              color: rgba(10, 151, 217, 1);
              i {
                font-size: 30px;
              }
            }
          }
        }
      }
      .more_new {
        display: flex;
        flex-direction: row;
        padding: 10px 30px;
        color: #fff;
        border-radius: 5px;
        background: #00689d;
        width: fit-content;
        justify-content: center;
        align-items: center;
        margin: 40px auto;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
      .noData {
        line-height: 60px;
        text-align: center;
        color: #999;
      }
      .Case_box_right_vedio_box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .tit {
          background: rgba(0, 87, 217, 1);
          color: #fff;
          display: inline-block;
          padding: 4px 20px;
        }
        .vedio_content {
          border: 2px solid rgba(247, 247, 247, 1);
          padding: 20px;
          .vedio_tit {
            font-size: 32px;
            color: rgba(0, 0, 0, 1);
          }
          .vedio_txt {
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            margin-top: 20px;
          }
          .vedio_box {
            margin-top: 20px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .NewList_Case {
    background: #fff;
    // width: 1200px;
    width: 100%;
  }
  .Case_box {
    padding-top: 20px;
    width: 1200px;
    margin: 0px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;

    // height: 600px;
    .fixed_true {
      position: fixed;
      bottom: 50px;
      width: 322px;
      background: #f8f8f8;

      // padding: 5px;
    }
    .Case_box_left {
      padding: 0 10px;
      width: 322px;
      background: #f8f8f8;
      .sdg_box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .sdg_box_img {
          cursor: pointer;
          width: 150px;
          height: 150px;
          position: relative;
          &:hover::after {
            padding: 10px;
            opacity: 1;
            font-size: 20px;
            transition: 0.5s ease;
          }
          &::after {
            opacity: 0;
            content: attr(data-attr);
            padding: 10px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 20px;
            font-weight: 600;
            //  font-size: 36px;

            z-index: 1;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
          }
          img {
            width: 100%;
            height: 100%;
            margin-bottom: 2px;
          }
        }
      }
      .share {
        margin-top: 36px;
        cursor: pointer;
        .tit {
          font-size: 24px;
          color: #000;
        }
        .share_icon {
          margin-top: 14px;
          i {
            font-size: 34px;
          }
          i:nth-child(1) {
            color: rgba(32, 89, 149, 1);
          }
          i:nth-child(2) {
            color: rgba(1, 154, 205, 1);
          }
          i:nth-child(3) {
            color: rgba(0, 171, 215, 1);
          }
        }
      }
      .report {
        cursor: pointer;
        margin-top: 40px;
        .tit {
          font-size: 24px;
          margin-bottom: 20px;
          color: #000;
        }
        .report_img:hover img {
          transition: 0.3s ease-in;
          transform: scale(1.2);
        }
        .report_img:hover::after {
          opacity: 1 !important;
          font-size: 20px;
          transition: 0.5s ease;
        }
        .report_img {
          position: relative;
          width: 302px;
          height: 174px;
          overflow: hidden;
        }
        .report_img::after {
          z-index: 1;
          content: "SDGs报告";
          color: #fff;
          font-size: 36px;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.3);
        }
        img {
          width: 302px;
          height: 174px;
          transition: 0.3s ease-in;
          object-fit: cover;
        }
      }
    }
    .Case_box_right {
      width: 844px;
      .Case_box_right_new:hover .Case_box_right_new_text .tit {
        background-size: 100% 2px !important;
      }
      .Case_box_right_new_box {
        display: flex;
        flex-direction: column;
        .Case_box_right_new:nth-child(even) {
          display: flex;
          flex-direction: row-reverse;
          .img_box {
            width: 342px;
            height: 255px;
            overflow: hidden;
            margin-left: 24px;
            img {
              transition: 0.2s;
              width: 342px;
              height: 255px;
              object-fit: cover;
            }
          }
        }
        .Case_box_right_new:nth-child(odd) {
          display: flex;
          flex-direction: row;
          .img_box {
            width: 342px;
            height: 255px;
            overflow: hidden;
            margin-right: 24px;
            img {
              width: 342px;
              height: 255px;
              object-fit: cover;
            }
          }
        }
        .Case_box_right_new:hover {
          background: #f8f8f8;
        }

        .Case_box_right_new {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 40px 0px;
          border-bottom: 1px solid #ccc;
          &:hover .img_box img {
            transition: 0.2s;
            transform: scale(1.1);
          }

          .Case_box_right_new_text {
            flex: 1;
            .tit_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;

              color: #fff;
              font-size: 24px;
              font-weight: 600;
              margin-bottom: 15px;

              .tit {
                background-image: linear-gradient(
                  rgba(0, 104, 157, 1),
                  rgba(0, 104, 157, 1)
                );
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
                color: rgba(0, 104, 157, 1);
                font-size: 32px;
              }
            }

            .date {
              margin-top: 10px;
              font-size: 24px;
              color: rgba(10, 151, 217, 1);
            }
            .content {
              color: rgba(51, 51, 51, 1);
              font-size: 16px;
              margin-top: 10px;
            }
            .arrows {
              text-align: right;
              margin: 10px;
              color: rgba(10, 151, 217, 1);
              i {
                font-size: 30px;
              }
            }
          }
        }
      }
      .more_new {
        display: flex;
        flex-direction: row;
        padding: 10px 30px;
        color: #fff;
        border-radius: 5px;
        background: #00689d;
        width: fit-content;
        justify-content: center;
        align-items: center;
        margin: 40px auto;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
      .noData {
        line-height: 60px;
        text-align: center;
        color: #999;
      }
      .Case_box_right_vedio_box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .tit {
          background: rgba(0, 87, 217, 1);
          color: #fff;
          display: inline-block;
          padding: 4px 20px;
        }
        .vedio_content {
          border: 2px solid rgba(247, 247, 247, 1);
          padding: 20px;
          .vedio_tit {
            font-size: 32px;
            color: rgba(0, 0, 0, 1);
          }
          .vedio_txt {
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            margin-top: 20px;
          }
          .vedio_box {
            margin-top: 20px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (max-width: 767px) {
  .NewList_Case {
    background: #fff;
    // width: 1200px;
    width: 100%;
  }
  .Case_box {
    padding-top: 20px;
    width: 100;
    margin: 0px auto 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 40px;

    // height: 600px;
    .fixed_true {
      position: fixed;
      bottom: 50px;
      width: 322px;
      background: #f8f8f8;

      // padding: 5px;
    }

    .Case_box_right {
      width: 100%;
      .Case_box_right_new:hover .Case_box_right_new_text .tit {
        background-size: 100% 2px !important;
      }
      .Case_box_right_new_box {
        display: flex;
        flex-direction: column;
        .Case_box_right_new {
          display: flex;
          flex-direction: column;
          .img_box {
            width: 100%;
            height: 255px;
            overflow: hidden;

            img {
              transition: 0.2s;
              width: 100%;
              height: 255px;
              object-fit: cover;
            }
          }
        }

        .Case_box_right_new {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding: 8px 10px 10px;
          border-bottom: 1px solid #ccc;

          .Case_box_right_new_text {
            flex: 1;
            .tit_box {
              word-wrap: break-word;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top: 7px;
              font-size: 22px;
              color: #fff;
              margin-bottom: 8px;

              color: #fff;
              font-size: 24px;
              font-weight: 600;
              margin-bottom: 15px;

              .tit {
                background-image: linear-gradient(
                  rgba(0, 104, 157, 1),
                  rgba(0, 104, 157, 1)
                );
                background-position: left bottom;
                background-repeat: no-repeat;
                transition: background-size 0.2s
                  cubic-bezier(0.55, 0.085, 0.68, 0.53);
                text-decoration: none;
                background-size: 0px 2px;
                color: rgba(0, 104, 157, 1);
                font-size: 24px;
              }
            }

            .date {
              margin-top: 10px;
              font-size: 24px;
              color: rgba(10, 151, 217, 1);
            }
            .content {
              color: rgba(51, 51, 51, 1);
              font-size: 16px;
              margin-top: 10px;
            }
            .arrows {
              text-align: right;
              margin: 10px;
              color: rgba(10, 151, 217, 1);
              i {
                font-size: 30px;
              }
            }
          }
        }
      }
      .more_new {
        display: flex;
        flex-direction: row;
        padding: 10px 30px;
        color: #fff;
        border-radius: 5px;
        background: #00689d;
        width: fit-content;
        justify-content: center;
        align-items: center;
        margin: 40px auto;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
      .noData {
        line-height: 60px;
        text-align: center;
        color: #999;
      }
      .Case_box_right_vedio_box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .tit {
          background: rgba(0, 87, 217, 1);
          color: #fff;
          display: inline-block;
          padding: 4px 20px;
        }
        .vedio_content {
          border: 2px solid rgba(247, 247, 247, 1);
          padding: 20px;
          .vedio_tit {
            font-size: 32px;
            color: rgba(0, 0, 0, 1);
          }
          .vedio_txt {
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            margin-top: 20px;
          }
          .vedio_box {
            margin-top: 20px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>